export const IS_CONFIG_READY = 'DEALER/CONFIG/READY';
